export default {
    1: {
        text: 'Activo',
        type: 'success',
        id: 3
    },
    0: {
        text: 'Inactivo',
        type: 'dark',
        id: 2
    }
};
